import styled from 'styled-components';

import { TextAppearance } from './Text';

import { Color } from '../../../shared/constants/Colors';
import { FontType } from '../../../shared/constants/Fonts';
import { MediaQuery } from '../../../shared/constants/Styles';
import { Typography } from '../../../shared/constants/Typographies';

export const Text = styled.div`
  font-family: ${FontType.PRIMARY};

  h1 {
    ${({ type }) =>
      type === TextAppearance.IMPORTANT
        ? Typography.HUGE_BOLDER
        : Typography.XXXXXL_BOLDER};

    color: ${Color.CLOUD_BURST};
  }

  h2 {
    ${({ type }) =>
      type === TextAppearance.ARTICLE
        ? Typography.XXXXL_BOLDER
        : Typography.XXXL_BOLDER};
    color: ${Color.CLOUD_BURST};
  }

  h3 {
    ${Typography.XXL_BOLDER};
    color: ${Color.CLOUD_BURST};
  }

  h4 {
    ${Typography.XL_BOLDER};
    color: ${Color.CLOUD_BURST};
  }

  h5 {
    ${Typography.L_BOLDER};
    color: ${Color.CLOUD_BURST};
  }

  h6 {
    ${Typography.M_BOLDER};
    color: ${Color.CLOUD_BURST};
  }

  ${({ center }) =>
    center === true &&
    `
      margin-top: auto;
      margin-bottom: auto;
  `};

  p,
  a,
  li {
    color: ${({ color }) => color || Color.DOLPHIN};
    ${({ type }) => type === TextAppearance.NORMAL && Typography.M};
    ${({ type }) => type === TextAppearance.ARTICLE && Typography.L};
    ${({ type }) => type === TextAppearance.REDUCED && Typography.S};
    ${({ type }) => type === TextAppearance.AUTHOR && Typography.XS_THINNER};
    ${({ type }) => type === TextAppearance.INFO && Typography.XS};
  }

  a {
    color: ${Color.BLUE_RIBBON};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  ul,
  ol {
    padding-left: 17px;
  }

  ul li,
  ol li {
    padding: 20px 0px 0px 10px;

    ${MediaQuery.S_AND_DOWN} {
      padding: 10px 0px 0px 5px;
    }
  }

  li {
    &::marker {
      color: ${Color.BLUE_RIBBON};
    }
  }
`;
